import { Card } from 'antd';
import React from 'react';

export type AppIntegration = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

type Props = {
  app: AppIntegration;
  onClick: any;
};

const AppIntegrationCard = ({ app, onClick }: Props) => {
  const { icon, title, description } = app;
  return (
    <Card onClick={onClick} hoverable style={{ maxWidth: 400 }}>
      <div style={{ height: 40, width: 40, marginBottom: 20 }}>{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
    </Card>
  );
};

export default AppIntegrationCard;
